export default __webpack_public_path__ + "static/11-7db27a6ac2b6d991aeca60be84e59a4d.webp";